import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { getPaywall, subscriptionCheck } from "../services/userApi";
import { useAuth, AuthData } from "./Auth";

const PremiumContext = React.createContext({});

export const usePremium = () => React.useContext(PremiumContext);

export const PremiumProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isPremium, setIsPremium] = React.useState(false);
  const [paywall, setPaywall] = React.useState<any>(null);
  const { authData } = useAuth() as { authData: AuthData };

  useQuery("subscriptionCheck", subscriptionCheck, {
    refetchIntervalInBackground: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    enabled: !!(authData && !!authData.id),
    cacheTime: 5 * 60 * 1000,
    staleTime: 3 * 60 * 1000,
    onSuccess: (res) => {
      if (
        res.data &&
        (res.data.premium || res.data.premiumLifetime || res.data.betaUser)
      ) {
        setIsPremium(true);
      } else {
        setIsPremium(false);
      }
    },
  });

  useQuery(["paywall", authData?.id], getPaywall, {
    enabled: !!(authData && !!authData.id),
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    onSuccess: (res) => {
      if (res?.data) {
        setPaywall(res.data);
      }
    },
  });

  useEffect(() => {
    if (authData && process.env.NODE_ENV !== "development") {
      LogRocket.init("redwing-tech/redwing");
      setupLogRocketReact(LogRocket);
      LogRocket.identify(`${authData.id}`, {
        name: `${authData.firstName} ${authData.lastName}`,
        email: `${authData.email}`,
        subscriptionType: isPremium ? "premium" : "free",
      });
    }
  }, [authData, isPremium]);

  return (
    <PremiumContext.Provider
      value={{
        isPremium: isPremium || authData?.premiumLifetime || authData?.betaUser,
        paywall,
        isReadOnly: Boolean(
          !(isPremium || authData?.premiumLifetime || authData?.betaUser) &&
            paywall?.isReadOnly
        ),
        setIsPremium,
      }}
    >
      {children}
    </PremiumContext.Provider>
  );
};
